export default {
  DotcomDesktopFooter__NEW_WINDOW_ARIA: "a11y-message-header--new-window",
};
